<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex>
        <v-img
          eager
          class="ma-auto"
          :src="cover"
          gradient="to bottom, rgba(84,176,228,.3), rgba(84,176,228,.3)"
        >
          <v-container fill-height>
            <v-flex justify-center>
              <v-container class="ma-auto">
                <v-img
                  width="37%"
                  style="opacity: 0.8"
                  class="ma-auto"
                  :src="whiteLogo"
                ></v-img>
              </v-container>
              <p
                style=" font-size: 35px; color: white; opacity: .8;"
                class="ma-auto pt-10 font-weight-bold text-center"
              >
                technology for animal welfare
              </p>
            </v-flex></v-container
          >
        </v-img>

        <v-layout id="start" class="ma-6">
          <p
            class="font-weight-bold d-flex ma-auto"
            style="font-size: 36px; white-space: nowrap;"
          >
            Herzlich Willkommen
          </p>
          <hr
            class="ma-auto mx-4"
            style="width: 100%; height:2px;border:none;color:#333;background-color:#333;"
          />
        </v-layout>

        <v-row class="ma-4">
          <v-col :lg="8" class="ma-auto">
            <v-card>
              <v-img eager contain :src="group"></v-img>
            </v-card>
          </v-col>

          <v-col :lg="4" class="ml-auto mr-auto">
            <v-card flat style="background: rgba(84,176,228,0.3); height:100%;">
              <v-card-title class="font-weight-bold">
                vetvise
              </v-card-title>
              <v-card-text style="font-size: 24px; line-height: 30px;">
                Für uns ist Tierwohl nicht nur ein Schlagwort, sondern die
                Quintessenz unserer Arbeit. Wir haben es uns zur Aufgabe
                gemacht, Tierwohlparameter wie Schmerzen oder Bewegung objektiv
                zu erfassen, sie auszuwerten und den Tierhaltern in einer leicht
                verständlichen Art und Weise wiederzugeben - damit Sie es
                einfach haben, es Ihrem Tier einfach zu machen!
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-card
          flat
          class="pt-10 pb-10 ma-4 mx-6"
          style="background:rgba(84, 176, 228, 0.75);"
        >
          <v-card-text
            style="font-size: 36px; line-height: 43px"
            class="font-weight-bold text-center"
          >
            „Tierwohl ist unser Antrieb, unsere Leidenschaft und die
            unverhandelbare Grundlage für jede Art der Tierhaltung.“
          </v-card-text>
        </v-card>

        <v-layout class="ma-6">
          <p
            class="font-weight-bold d-flex ma-auto"
            style="font-size: 36px; white-space: nowrap;"
          >
            Unsere Lösungen
          </p>
          <hr
            class="ma-auto mx-4"
            style="width: 100%; height:2px;border:none;color:#333;background-color:#333;"
          />
        </v-layout>

        <v-row class="ma-4">
          <v-col :lg="8">
            <v-card
              flat
              style="background: rgba(126, 183, 92,.3); height:100%;"
            >
              <v-card-title id="haustier" class="font-weight-bold"
                >Haustiere</v-card-title
              >
              <v-card-text style="font-size: 24px; line-height: 30px;">
                <h4 class="mb-2 mt-4">Tino für Tierbesitzer</h4>
                <p>
                  Tino, die Tiernotfall-App, ist die “Leitzentrale” für den
                  “Fall der Fälle”, die wir gemeinsam mit dem “Bundesverband der
                  praktizierenden Tierärzte e.V.” entwickeln. Sobald Sie während
                  der Notdienstzeiten das Gefühl haben, dass Ihr Tier einen
                  Notfall hat, verbinden wir Sie mit Ihrem Haustierarzt oder
                  einem anderen Tierarzt, der in der Lage ist Ihr Tier zu
                  behandeln. So kann per Chat oder Videotelefonie schnell
                  geklärt werden, ob wirklich akut ein Tierarztbesuch notwendig
                  ist oder ob ein normaler Termin am nächsten Tag reicht.
                </p>
                <h4 class="mb-2 mt-4">Tino für Tierärzte</h4>
                <p>
                  Gestalten Sie Ihren Notdienst einfacher, flexibler und
                  effizienter und verbessern Sie gleichzeitig noch Ihr
                  Beratungsangebot! Mit Tino können Sie entscheiden, wann Sie im
                  Notdienst erreichbar sind und auswählen, welche Fälle Sie
                  behandeln oder beraten wollen. Über unsere intelligente
                  Vorauswahl bekommen Sie nur Fälle, die Sie auch in Ihrer
                  Praxis behandeln könnten. Das Honorar für die Beratung können
                  Sie GOT-Konform übrigens selber festlegen!
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col :lg="4">
            <v-card flat style="height:100%">
              <v-img
                eager
                style="height:100%"
                position="80%"
                cover
                :src="dog"
              ></v-img
            ></v-card>
          </v-col>
        </v-row>

        <v-row class="ma-4">
          <v-col :lg="4">
            <v-card flat style="height:100%">
              <v-img
                eager
                style="height:100%"
                position="center"
                cover
                :src="cow"
              ></v-img
            ></v-card>
          </v-col>

          <v-col :lg="8">
            <v-card flat style="background: rgba(231,171,0,0.3); height:100%;">
              <v-card-title id="nutztier" class="font-weight-bold"
                >Nutztiere</v-card-title
              >
              <v-card-text class="cardText text--primary">
                <p>
                  In der modernen Schweinehaltung fällt es häufig schwer zu
                  sehen, ob ein einzelnes Tier Schmerzen hat oder krank ist. Wir
                  entwickeln Lösungen, mit denen wir über das Bewegungsverhalten
                  der Tiere dies einschätzen können, um Krankheiten, Schmerzen
                  oder Schwanzbeißen schon im Moment des Auftretens behandeln zu
                  können. Unsere Vision ist es, Vorhersagen treffen zu können,
                  um zu verhindern, dass ein Tier überhaupt krank wird oder
                  Verhaltensstörungen auftreten.
                </p>
                <p>
                  Lahmheiten sind ein großes Problem in der Sauenhaltung und
                  viele dieser Lahmheiten gehen auf Probleme mit den Klauen
                  zurück. Wir haben ein System entwickelt, mit dem schon über
                  ein einfaches Foto im Saugferkelalter eine Einschätzung zu
                  einem wichtigen Faktor in der Klauengesundheit - der Symmetrie
                  - möglich wird. So können frühzeitig die gesündesten Füße für
                  die weitere Zucht entdeckt und Schmerzen im späteren Leben
                  einfach vermieden werden.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-layout id="team" class="ma-6">
          <p
            class="font-weight-bold d-flex ma-auto"
            style="font-size: 36px; white-space: nowrap;"
          >
            Team
          </p>
          <hr
            class="ma-auto mx-4"
            style="width: 100%; height:2px;border:none;color:#333;background-color:#333;"
          />
        </v-layout>

        <v-row class="ma-4">
          <v-col :lg="8">
            <v-card
              flat
              style="height:100%; background: rgba(84, 176, 228, 0.5);"
            >
              <v-card-title class="font-weight-bold">
                Wir als Team
              </v-card-title>
              <v-card-text style="font-size: 24px; line-height: 30px;">
                Unser Team verbindet tiermedizinisches Wissen mit modernem
                Data-Engineering, um Ihnen als Tierhalter wieder mehr Zeit für
                Ihre Tiere zu geben. Dabei achten wir auf die kleinen und
                unscheinbar erscheinenden Probleme, da diese häufig im
                Arbeitsalltag untergehen. Doch gerade diese Probleme lassen sich
                mit unseren Analyse-Methoden unkompliziert aufspüren und
                verbessern. Wir wollen allen Tierhaltern, privaten wie
                professionellen, die Werkzeuge in die Hand geben, die sie
                benötigen um das Wohlergehen ihrer Tiere sicher zu stellen und
                verbessern zu können. Dabei verzichten wir auf hochkomplexe
                Geräte oder teure Technik, sondern setzen auf
                Alltagstauglichkeit und einfache Bedienbarkeit.
              </v-card-text>
            </v-card>
          </v-col>
          <v-col :lg="4">
            <v-card flat>
              <v-img eager :src="portraitJo"></v-img>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="ma-4">
          <v-col :lg="4">
            <v-card>
              <v-img eager :src="portraitNo"></v-img>
            </v-card>
          </v-col>
          <v-col :lg="4">
            <v-card flat style="height:100%">
              <v-img eager style="height:100%" :src="portraitJa"></v-img>
            </v-card>
          </v-col>
          <v-col :lg="4">
            <v-card
              flat
              style="height:100%; background: rgba(84, 176, 228, 0.5);"
            >
              <v-card-text style="font-size: 24px; line-height: 30px;">
                Wir als multidisziplinäres Team schauen gerne über den
                Tellerrand hinaus um mehr darüber zu lernen, was Ihnen als
                Tierhalter wichtig ist. Dafür arbeiten wir beispielsweise mit
                der Stiftung Tierärztlichen Hochschule Hannover oder dem
                Bundesverband der praktizierenden Tierärzte e.V. zusammen, um am
                Puls der Zeit zu bleiben. Für uns ist der Austausch mit Ihnen
                die Voraussetzung für exzellente Anwendungen!
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-layout id="unterstuetzende" class="ma-6">
          <p
            class="font-weight-bold d-flex ma-auto"
            style="font-size: 36px; white-space: nowrap;"
          >
            Unterstützende
          </p>
          <hr
            class="ma-auto mx-4"
            style="width: 100%; height:2px;border:none;color:#333;background-color:#333;"
          />
        </v-layout>

        <v-card
          outlined
          class="ma-4"
          style="border-color: rgba(84, 176, 228, 0.5); border-width: 2px; border-radius: 12px;"
        >
          <v-row>
            <v-col :cols="10" :lg="2" class="ma-auto py-8">
              <v-img eager contain :src="logoTiho"></v-img>
            </v-col>
          </v-row>

          <v-row>
            <v-col :cols="10" :lg="2" class="ma-auto py-8">
              <v-img eager contain :src="logoBMWI"></v-img>
            </v-col>
            <v-col :cols="10" :lg="2" class="ma-auto py-8">
              <v-img eager contain :src="logoExist"></v-img>
            </v-col>
            <v-col :cols="10" :lg="2" class="ma-auto py-8">
              <v-img eager contain :src="logoESF"></v-img>
            </v-col>
            <v-col :cols="10" :lg="2" class="ma-auto py-8">
              <v-img
                eager
                width="70%"
                class="ma-auto"
                contain
                :src="logoEU"
              ></v-img>
            </v-col>
            <v-col :cols="10" :lg="2" class="ma-auto">
              <v-img eager contain :src="logoZZG"></v-img>
            </v-col>
          </v-row>
        </v-card>

        <v-img eager :aspect-ratio="3" cover :src="pig"></v-img>

        <v-layout id="presse" class="ma-6">
          <p
            class="font-weight-bold d-flex ma-auto"
            style="font-size: 36px; white-space: nowrap;"
          >
            Presse
          </p>
          <hr
            class="ma-auto mx-4"
            style="width: 100%; height:2px;border:none;color:#333;background-color:#333;"
          />
        </v-layout>

        <v-row class="ma-4">
          <v-col :lg="4">
            <v-card>
              <v-img eager height="100%" :src="group2"></v-img>
            </v-card>
          </v-col>
          <v-col :lg="8" class="ml-auto mr-auto">
            <v-card flat style="background: rgba(84,176,228,0.3); height:100%;">
              <v-card-text
                class="cardText"
                style="font-size: 24px; line-height: 30px;"
              >
                vetvise ist ein junges Start-up aus Hannover, das sich zum Ziel
                gesetzt hat, das Tierwohl von Nutz- und Haustieren durch eine
                Kombination aus klassischem, tiermedizinischem Wissen und
                modernsten Software-Verfahren, wie Machine-Learning, zu
                verbessern. Der Fokus von vetvise liegt auf der Auswertung von
                Bild- und Videodaten über Machine-Learning Verfahren und der
                Aufbereitung dieser Daten, sodass sie für Tierärzte und
                Tierbesitzer verständlich und hilfreich sind. vetvise konnte ein
                EXIST-Gründerstipendium des Bundesministeriums für Wirtschaft
                und Energie einwerben. Aktuell wird der Launch der
                Tiernotfall-Leitzentrale “Tino” vorbereitet. Über diese App kann
                ein Tierbesitzer im Notfall in kürzester Zeit den Kontakt zu
                einem Tierarzt bekommen und direkt über das Smartphone per Chat
                oder (Video-)telefonie beraten werden. Außerdem ist eine
                Tier-Krankenakte in Tino integriert.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-container
          id="kontakt"
          style="background: rgba(84,176,228,0.5); max-width: unset"
        >
          <v-row>
            <v-col>
              <v-btn text block v-on:click="openLegalNotice">Impressum</v-btn>

              <v-btn v-on:click="openPrivacyNotice" text block
                >Datenschutz</v-btn
              >
            </v-col>

            <v-col>
              <v-btn v-on:click="$vuetify.goTo('#haustier')" text block
                >Haustier</v-btn
              >
              <v-btn v-on:click="$vuetify.goTo('#nutztier')" text block
                >Nutztier</v-btn
              >
              <v-btn v-on:click="$vuetify.goTo('#presse')" text block
                >Pressekit</v-btn
              >
            </v-col>

            <v-col>
              <v-btn text block>Kontakt</v-btn>
              <v-btn text block>info@vetvise.com</v-btn>
            </v-col>
          </v-row>
          <hr
            class="mr-4 ml-4 d-none d-sm-block"
            style="height:2px;border:none;color: #ffffff;background-color:#ffffff;"
          />

          <v-row>
            <v-col class="text-center">
              Caspari, Schmidt-Mosig und Wendt - vetvise GbR
            </v-col>

            <v-col class="text-center">
              Sandbergstr. 95, 26180 Rastede
            </v-col>

            <v-col class="text-center">
              Copyright vetvise 2019
            </v-col>
          </v-row>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      cover: require("../assets/images/cover.jpeg"),
      group: require("../assets/images/group.jpeg"),
      group2: require("../assets/images/group2.jpeg"),
      image: require("../assets/vetvise_logo.svg"),
      dog: require("../assets/images/dog.jpeg"),
      cow: require("../assets/images/cow.jpeg"),
      whiteLogo: require("../assets/images/logoWhite.svg"),
      portraitJo: require("../assets/images/jo_portrait.jpeg"),
      portraitNo: require("../assets/images/no_portrait.jpeg"),
      portraitJa: require("../assets/images/ja_portrait.jpeg"),
      pig: require("../assets/images/pig.jpeg"),
      logoExist: require("../assets/images/logoExist.svg"),
      logoBMWI: require("../assets/images/logoBMWI.jpg"),
      logoESF: require("../assets/images/logoESF.svg"),
      logoEU: require("../assets/images/logoEU.svg"),
      logoZZG: require("../assets/images/logoZZG.svg"),
      logoTiho: require("../assets/images/logoTiho.png")
    };
  },

  methods: {
    openPrivacyNotice() {
      this.$emit("openPrivacyNotice");
    },
    openLegalNotice() {
      this.$emit("openLegalNotice");
    }
  }
};
</script>
<style scoped>
.v-card {
  border-radius: 12px;
  height: 100%;
}
.v-card__text {
  color: black !important;
  opacity: 0.85 !important;
  font-size: 24px !important;
  line-height: 30px !important;
}
.v-card__title {
  font-size: 28px;
}
</style>
